import { Avatar, styled } from '@mui/material'
import { css } from '@emotion/css'

export const ImageSt = styled('img')`
  width: 100%;
  height: 55vh;
  object-fit: cover;
`

export const VideoSt = styled('video')`
  width: 100%;
  height: 55vh;
  object-fit: cover;
  display: block;
`

export const ImageWrapper = styled('div') <{ withIndicator: boolean }>`
  position: relative; 
  height: ${({ withIndicator }) => (withIndicator ? '60vh' : '55vh')};
  justify-content: center;

  text-align: center;
  overflow: hidden;

  ${({ theme }) => theme.breakpoints.down('md')} {
    /* position: sticky; */
    z-index: 0;
    left: 0;
    top: 0;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    position: relative;
  }
`

export const MediaContainer = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
`

export const List = styled('ul', {
  shouldForwardProp: (prop) => prop !== 'withIndicator' && prop !== 'placement',
})<{ withIndicator: boolean; placement?: 'top' | 'bottom' }>(
  ({ withIndicator, placement = 'bottom' }) => ({
    position: 'absolute',
    left: 0,
    ...(placement === 'top'
      ? { top: '24px', alignItems: 'flex-start' }
      : { bottom: withIndicator ? '85px' : '55px', alignItems: 'flex-end' }),
    width: '100%',
    padding: '0 16px',
    boxSizing: 'border-box',
    zIndex: 10,
    pointerEvents: 'none',
    margin: 0,

    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '8px',
  }),
)



export const ListImage = styled(Avatar)`
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 40px;
    height: 40px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 44px;
    height: 44px;
  }

  border-radius: 6px;
`

export const TitleItem = styled('li')`
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 0;
  /* margin-bottom: 16px; */
  pointer-events: auto;
`

export const ListImageWrapper = styled('li')`
  pointer-events: auto;
`

export const mediaCarousel = css`
  & > div > div > div > div {
    position: static !important;
  }
`

export const navButtonWrapper = css`
  margin: 0 10px;
  :hover {
    button {
      background-color: #000;
      filter: brightness(120%);
      opacity: 0.8 !important;
    }
  }
  :hover {
    button:hover {
      /* opacity: 0.8 !important; */
    }
  }
`
export const navIcon = css`
  color: white;
  /* opacity: 0.8; */
  transition: all 0.3s ease-in-out;
  :hover {
    /* opacity: 0.8; */
  }
`
export const indicatorWrapper = css`
  margin-top: 15px !important;
`
